import React, {Fragment, useState, useRef} from 'react';

import { Globals, handleAjaxError, checkError, displayAlert } from './globals' ;

import VanillaModal from "root/Modals/VanillaModal/VanillaModal";

import UserInput from './ui/ReactUserInput' ;
import {UserType} from "root/DataFunctions/Constants";
import ModalPrivacyStatement from "./ModalPrivacyStatement";
import Modal from "react-responsive-modal";
import {fromBase64} from "js-base64";
import {doRegister, doPasswordReset} from "root/DataFunctions/LoginFns";
import { getDataFromResponse } from "root/DataFunctions/BaseDataFns";

const LoginForm = ({
	mode: initialMode = 'login',
	user_type: initialUserType,
	user_id: initialUserId,
	token,
	username,
	establishment_number: initialEstablishmentNumber,
	reason,
	title: heading,
	useProvider = true,
	suppressLogo = false,
	defaultLogo = '/style/images/seven360/ncc_logo.png'
}) =>
{
	const USER_TYPE_FIELD_NAME = 'user_type_id' ;
	const USER_ID_FIELD_NAME = 'user_id' ;
	const LOGIN_URL = "/login" ;
	const WELCOME_TITLE = 'Welcome to the Safeguarding Audit!';
	const WELCOME_TITLE_PASSWORD_RESET = 'Safeguarding Audit Password Reset';

	const [ mode, setMode ] = useState ( initialMode === '' || initialMode === null ? 'login' : initialMode ) ;
	const [ user_type, setUserType ] = useState ( initialUserType ) ;
	const [ user_id, setUserId ] = useState ( initialUserId ) ;
	const [ user, setUser ] = useState ( [] ) ;
	const [ error, setError ] = useState ( { displayErrors : false, formError: null} ) ;

	const inpEstablishmentNumber = useRef(null);
	const inpUsername = useRef(null);
	const inpOldPassword = useRef(null);
	const inpPassword1 = useRef(null);
	const inpPassword = useRef(null);

	const [ dialogPrivacyOpen, setDialogPrivacyOpen ] = useState (false);

	const doSetFocus = () =>
	{
		switch ( mode )
		{
			case 'login' :
			case 'password_reset_complete' :
				inpEstablishmentNumber.current.focus() ;
				break ;			
			case 'change_password' :
				inpOldPassword.current.focus() ;
				break ;			
			case 'change_password_first' :
			case 'register' :
			case 'activate' :
				inpPassword.current.focus() ;
				break ;
			case 'forgot_password' :
				inpEstablishmentNumber.current.focus() ;
				break ;			
		}	
	}

	const redirectKnownUserType = ( user_type ) =>
	{
        switch (+user_type)
        {
            case UserType.USER_TYPE_LOCAL_AUTHORITY_MANAGER :
				window.location.replace("/school");
				break;
			case UserType.USER_TYPE_GOVERNOR :
			case UserType.USER_TYPE_DSL :
                window.location.replace("/home");
                break;
            default:
                displayAlert({title: "Error", message: "Invalid User Type - please contact your system administrator"});
                break;
        }
	}
	
	const doPasswordResetConfirmation = ( user ) =>
	{
		dialogShow ( 'Password Reset Accepted', '<p>You have successfully requested a password reset. Please check your email for confirmation and further instructions.</p>',
			() => {
				setMode ( 'login') ;
			} ) ;
	}

	const doLoginFunctions = ( user ) =>
	{
        const user_type = user[USER_TYPE_FIELD_NAME];
        const userid = user[USER_ID_FIELD_NAME];
        
		if ( +(user.password_change_required) === 1 )
		{
			dialogShow ( 'Successful Login', '<p>You have successfully logged in, but you must now change your password before continuing.</p>',
				() => {
					setMode ('change_password_first') ;
					setUserType(user_type);
					setUserId (userid) ;
				} ) ;
		}
		else
		{
            redirectKnownUserType ( user_type ) ;
		}
	}

	const doChangePassword = ( userid, newpass ) =>
	{
		const url = Globals.APIFolder + '/users/' + userid+ '/changepassword/' + newpass ;

        $.ajax({
            type: 'PUT',
            url: url ,
            success:(data)=>{

    			if ( checkError(data))
				{
    				redirectKnownUserType ( user_type )
				}  				

            },
            error:(jqXHR, textStatus, error)=>
            {
				handleAjaxError ( jqXHR, textStatus, error) ;    		  	
            }
        });
		
	}
	
	const doChangeCurrentUserPassword = ( oldpass, newpass ) =>
	{
		const url = Globals.APIFolder + '/changepassword' ;

		let data = { oldpassword: oldpass, password: newpass } ;
		
        $.ajax({
            type: 'PUT',
            url: url ,
            data: { data },
            success:(data)=>{

    			if ( checkError(data))
				{
					dialogShow ( 'Password change successful', '<p>Your password has now been changed.</p>',
						() => {
							setMode('password_changed') ;
						} ) ;
				}

            },
            error:(jqXHR, textStatus, error)=>
            {
				handleAjaxError ( jqXHR, textStatus, error) ;    		  	
            }
        });
	}
//removed this inpEstablishmentNumber: establishment

	const dialogShow = ( title, message, action ) =>
	{
		let cfrm = new VanillaModal ({
			title: title,
			content: message,
			buttons: VanillaModal.buttons.alert
		})

		// Listen for `hide` event.
		/* cfrm.on('hide', function() {
			alert('Triggered hide event.');
		}); */

		// Listen for `hidden` event.
		/* cfrm.on('hidden', function() {
			alert('Modal is hidden.');
		}); */

		/* cfrm.on('dismiss', function() {
			alert('Modal is hidden.');
		}); */

		cfrm.show().once('dismiss', (modal, ev, button) => {
		if (button && button.value) {
			action() ;
		}
		});;
	}

	const doLogin = ( username, password, establishment ) =>
	{
		const url = Globals.APIFolder + LOGIN_URL ;
		
    	$.ajax({
    		  type: 'POST',
    		  url: url,
    		  data: { inpUsername: username, inpPassword: password },
    		  success:(data)=>
    		  {
    		  	if ( checkError(data))
				{
					const return_data = getDataFromResponse(data)[0];

					if ( return_data.login_result === 'success')
					{
						var user = return_data ;

						if ( user.privacy_statement_read_date !== undefined && user.privacy_statement_read_date == null )
						{
							setMode ('privacy_statement') ;
							setUser(user) ;
							setDialogPrivacyOpen (true);
						}
						else
						{
							doLoginFunctions( user );
						}
					}
					else
					{
						if (return_data.reason === "invalid")
						{
							dialogShow ( 'Login Failed', '<p>The credentials you entered are invalid. Please try again.</p>',
								() => {
								setMode ( 'login') ;
							} ) ;
						}
						else if (return_data.reason === "inactive")
						{
							dialogShow ( 'Login Failed', '<p>The account has not yet been activated.</p><p>Please check your email for an activation email or contact your system administrator.</p>',
								() => {
									setMode ( 'login') ;
								} ) ;
						}
						else if (return_data.reason === "suspended")
						{
							dialogShow ( 'Login Failed', '<p>The account has been suspended. Please contact your system administrator.</p>',
								() => {
									setMode ( 'login') ;
								} ) ;
						}
					}
				}
    		  },
    		  error:(jqXHR, textStatus, error)=>
    		  {
					handleAjaxError ( jqXHR, textStatus, error) ;    		  	
		  	  }

    		});
	}

	const doResetPasswordSet = ( newpass ) =>
	{
		const url = Globals.APIFolder + '/resetpassword/set' ;

		const data = {
			password: newpass,
			token: token
		} ;

		$.ajax({
			type: 'POST',
			url: url ,
			data: data,
			success:(data)=>
			{
				if ( checkError(data))
				{
					setMode( 'password_reset_complete')
				}
			},
			error:(jqXHR, textStatus, error)=>
			{
				handleAjaxError ( jqXHR, textStatus, error) ;
			}
		});

	}

	const onForgotPassword = () =>
	{
		setMode ('forgot_password') ;
	}

	const onForgotPasswordCancel = () =>
	{
		setMode('login') ;
	}

	const onLogout = () =>
	{
		setMode('login') ;
	}

	const onCancel = () =>
	{
      	location.assign('home.php');
	}

	const onChangePasswordCancel = () =>
	{
		setMode ('change_password') ;
	}

	const formIsValid = () =>
	{
		switch ( mode )
		{
			case 'login' :
			case 'password_reset_complete' :
			case 'activate' :
				if ( inpUsername.current.isValid() && inpPassword.current.isValid())
				{
					return true ;
				}
				else
				{
					return false ;
				}
				break ;			
			case 'change_password' :
				if ( inpOldPassword.current.isValid() && inpPassword.current.isValid() && inpPassword1.current.isValid())
				{
					return true ;
				}
				else
				{
					return false ;
				}
				break ;			
			case 'change_password_first' :
			case 'password_reset' :
			case 'register' :
				if ( inpPassword.current.isValid() && inpPassword1.current.isValid())
				{
					return true ;
				}
				else
				{
					return false ;
				}
				break ;			
			case 'forgot_password' :
				if ( inpUsername.current.isValid())
				{
					return true ;
				}
				else
				{
					return false ;
				}
				break ;			
		}
		
		return false ;
	}

	const getEstablishmentNumber = () =>
	{
		if ( useProvider === true )
		{
			return inpEstablishmentNumber.current.getValue() ;
		}
		else
		{
			return null ;
		}
	}

	const getFormData = () =>
	{
		let dataItem = {} ;
		
		switch ( mode )
		{
			case 'login' :
			case 'password_reset_complete' :
			case 'activate' :
				dataItem.username= inpUsername.current.getValue() ;
				dataItem.password = inpPassword.current.getValue() ;
				//dataItem.establishment_number = getEstablishmentNumber();
				break ;
			case 'change_password' :
				dataItem.oldpassword= inpOldPassword.current.getValue() ;
				dataItem.password= inpPassword.current.getValue() ;
				dataItem.password1 = inpPassword1.current.getValue() ;
			case 'change_password_first' :
			case 'register' :
			case 'password_reset' :
				dataItem.password= inpPassword.current.getValue() ;
				dataItem.password1 = inpPassword1.current.getValue() ;
				break ;
			case 'forgot_password' :
				dataItem.username= inpUsername.current.getValue() ;
				//dataItem.establishment_number = getEstablishmentNumber();
				break ;
		}
		
		return dataItem ;
	}
//removed this data.establishment_number
	const onLogin = (event) =>
	{
		event.preventDefault() ;
		
		if ( !formIsValid())
		{
			setError({ displayErrors: true, formError: null});
		}
		else
		{
			const data = getFormData() ;
			
			doLogin( data.username, data.password );
		}
	}

	const onRegister = (event) =>
	{
		event.preventDefault() ;

		if ( !formIsValid())
		{
			setError({ displayErrors: true, formError: null});
		}
		else
		{
			const data = getFormData() ;

			if ( data.password !== data.password1 )
			{
				setError ({ displayErrors : true, formError: "Passwords must match"}) ;
			}
			else
			{
				doRegister(data.password, token,(response) =>
				{
					setMode ('register_complete') ;
				})
			}
		}
	}

	//removed this data.establishment_number from the else
	const onForgotPasswordSend = (event) =>
	{
		if ( !formIsValid())
		{
			setError({ displayErrors: true, formError: null});

		}
		else
		{
			const data = getFormData() ;

			doPasswordReset ( data.username, (response) =>
			{
				doPasswordResetConfirmation( );
			})
		}
	}

	const onSavePasswordReset = (event) =>
	{
		event.preventDefault() ;

		if ( !formIsValid())
		{
			setError({ displayErrors: true, formError: null});
		}
		else
		{
			const data = getFormData() ;

			doResetPasswordSet( data.password, (response) =>
			{
				console.log ( "Password reset completed") ;
			});
		}
	}

	const onChangePassword = (event) =>
	{
		event.preventDefault() ;
		
		if ( !formIsValid())
		{
			setError({ displayErrors: true, formError: ''});
		}
		else
		{
			const data = getFormData() ;

			if ( data.password !== data.password1 )
			{
				setError({ displayErrors: true, formError: 'Passwords must match'});
			}
			else
			{
				if ( mode === 'change_password_first')
				{
					doChangePassword( user_id, data.password );
				}
				else
				{
					doChangeCurrentUserPassword(data.oldpassword, data.password );
				}
			}
		}
	}

    const logo = ( image_path ) =>
    {
        return (
				<img src={image_path} alt='logo'/>
		)
    }
    
    const title = ( title ) =>
    {
        // return <h1>{title}</h1>
    }

	const renderEstablishmentInput = ( providerAutoFocus, establishment_number ) =>
	{
		return <UserInput
			validation={{required: false, maxlen: 100 }}
			id='inpEstablishmentNumber'
			name='inpEstablishmentNumber'
			ref={inpEstablishmentNumber}
			autofocus={providerAutoFocus}
			labelText={null}
			errorText='You must enter a valid establishment number'
			placeholder='Establishment Number'
			value={establishment_number}
			tabIndex={1}
			displayErrors={error.displayErrors}
			key='inpEstablishmentNumber' />
	}

	const renderUserNameInput = ( userAutoFocus, value ) =>
	{
		return <UserInput
			validation={{required: true, maxlen: 100 }}
			id='inpUsername'
			name='inpUsername'
			ref={inpUsername}
			autofocus={userAutoFocus}
			labelText={null}
			errorText='You must enter a valid username'
			placeholder='Username'
			tabIndex={2}
			value={value}
			displayErrors={error.displayErrors}
			containerClassName=''
			key='inpUsername' />
	}

	const renderPasswordInput = ( userAutoFocus, placeHolder ) =>
	{
		return <UserInput
			validation={{required: true, maxlen: 100 }}
			id='inpPassword'
			name='inpPassword'
			isPassword={true}
			ref={inpPassword}
			autofocus={userAutoFocus}
			labelText={null}
			errorText='You must enter a password'
			placeholder={placeHolder}
			tabIndex={3}
			value=''
			displayErrors={error.displayErrors}
			containerClassName=''
			key='inpPassword' />
	}

    const formElement = () =>
    {
    	let lineList = [] ;
    	let value = '' ;
    	let establishment_number = '';

		let providerAutoFocus = false ;
    	let userAutoFocus = true ;
		let passwordAutoFocus = false ;

    	if ( mode === 'activate' )
		{
			lineList.push  (<p key='ac1'>Your account is now activated.</p>) ;
			lineList.push  (<p key='ac2'>Please enter your password below to log in.</p>) ;
			value = fromBase64(username) ;
			establishment_number = initialEstablishmentNumber ;
			providerAutoFocus = false ;
			userAutoFocus = false ;
			passwordAutoFocus = true ;
		}
    	else if ( mode === 'password_reset_complete' )
		{
			lineList.push  (<p key='ac1'>Your password has been changed.</p>) ;
			lineList.push  (<p key='ac2'>Please enter your new password below to log in.</p>);
			value = username ;
			establishment_number = initialEstablishmentNumber ;
			providerAutoFocus = true ;
			userAutoFocus = false ;
			passwordAutoFocus = false ;
		}
    	else if ( mode === 'login' && reason === 'inactive' )
		{
			userAutoFocus = true ;
			passwordAutoFocus = false ;
			establishment_number = initialEstablishmentNumber ;

			lineList.push (
				<div key='ssowarning' className='sso-warning'>
					<p>Your Single Sign-on has failed because your account is not yet activated.</p>
					<p>Please check your email for an activation invitation before attempting to login using Single Sign-On</p>
				</div>
			);
		}
		else if ( mode === 'login' && reason === 'invalid_school' )
		{
			establishment_number = initialEstablishmentNumber ;

			lineList.push (
				<div key='ssowarning' className='sso-warning'>
					<p>Your Single Sign-on has failed because your school is not enabled.</p>
					<p>Please contact your system administrator.</p>
				</div>
			);
		}

		if ( useProvider === true )
		{
			lineList.push ( renderEstablishmentInput ( providerAutoFocus, establishment_number )) ;
		}

		if ( reason === 'timeout' )
		{
			const style = {
				marginBottom: '15px',
				textAlign: 'center',
				color: '#ff263a'
			}

			lineList.push ( <div key='timeout' style={style}>Your session was logged out due to inactivity</div>) ;
		}

		lineList.push ( renderUserNameInput (userAutoFocus, value)) ;

		lineList.push ( renderPasswordInput (passwordAutoFocus, 'Password')) ;

		lineList.push ( React.createElement ( 'button', { type: 'submit', key: 'btnLogin', className: 'btn btn-primary', id: 'submitBtn', onClick: onLogin }, 'Log in')) ;

    	return React.createElement ( 'form', { key: 'loginForm', className: 'form', id: 'login_form'},
			React.createElement ( 'div', { key: 'loginFormGroup', className: 'form-group'},
				lineList )) ;
    }

    const forgotPasswordformElement = () =>
    {
		return (
			<form className='form' id='login_form'>
				{ useProvider === true && renderEstablishmentInput ( true, '' ) }
				{ renderUserNameInput(false, '') }
				<div className='form-group'>
					<button type='button' className='btn btn-primary' id='submitBtn' style={{marginBottom: '15px'}} onClick={onForgotPasswordSend}>Reset Password</button>
				</div>
				<div className='form-group'>
					<button type='button' className='btn btn-secondary' id='cancelBtn' onClick={onForgotPasswordCancel}>Cancel</button>
				</div>
			</form>
		)
	}

	const registerElement = () =>
	{
		let errorMessage = error.formError === null ? "You must enter a valid password" : error.formError ;
		let validation = { required: true, maxlen: 100, forceError: error.formError !== null } ;

		return (
			<form className='form' id='login_form'>
				<p className='welcome-title'>{WELCOME_TITLE}</p>
				<p className='welcome-body'>Please choose a password ( at least 8 letters, including a number and an
					upper-case letter ) and click 'Register' to complete the registration process.</p>
				{renderPasswordInput(true, 'New Password')}
				<UserInput
					validation={validation}
					id='inpPassword1'
					name='inpPassword1'
					isPassword={true}
					ref={inpPassword1}
					labelText={null}
					errorText={errorMessage}
					placeholder={'Confirm Password'}
					tabIndex={3}
					value=''
					displayErrors={error.displayErrors}
					containerClassName=''
					key='inpPassword1'/>
				<div className='form-group'>
					<button type='button' className='btn btn-primary' id='submitBtn' onClick={onRegister}>Register</button>
				</div>
			</form>
		)
	}

	const passwordReset = () =>
	{
		let errorMessage = error.formError === null ? "You must enter a valid password" : error.formError ;
		let validation = { required: true, maxlen: 100, forceError: error.formError !== null } ;

		return (
			<form className='form' id='login_form'>
				<p className='welcome-title'>{ WELCOME_TITLE_PASSWORD_RESET }</p>
				<p className='welcome-body'>Please choose a new password ( at least 8 letters, including a number and an upper-case letter ) and click 'Change Password' to complete the process.</p>
				{renderPasswordInput(true, 'New Password')}
				<UserInput
					validation={validation}
					id='inpPassword1'
					name='inpPassword1'
					isPassword={true}
					ref={inpPassword1}
					labelText={null}
					errorText={errorMessage}
					placeholder={'Confirm Password'}
					tabIndex={3}
					value=''
					displayErrors={error.displayErrors}
					containerClassName=''
					key='inpPassword1'/>
				<div className='form-group'>
					<button type='button' className='btn btn-primary' id='submitBtn' onClick={onSavePasswordReset}>Reset Password</button>
				</div>
			</form>
		)
	}

	const pStyle = {textAlign: 'center'} ;

	const registerCompleteElement = ( ) =>
	{
		return <form key='complete' className='form' id='login_form'>
			<p style={pStyle} key='rc1'>Thank You.</p>
			<p style={pStyle} key='rc2'>The registration process is almost complete.</p>
			<p style={pStyle} key='rc3'>You will now be sent an activation email which will contain a link that you can click to activate your account and log in. Please check your email now for the activation email.</p>
		</form>
	}

	const passwordChangeCompleteElement = () =>
	{
		return (
			<form key='passwordChangeComplete' className='form' id='login_form'>
				<p style={pStyle} key='pwc1'>Thank You.</p>
				<p style={pStyle} key='pwc2'>Your password has been changed.</p>
			</form>
		)
	}

	const changePasswordformElement = ( requireOldPassword ) =>
    {
		let errorMessage = error.formError === null ? "You must enter a valid password" : error.formError ;
		let validation = { required: true, maxlen: 100, forceError: error.formError !== null } ;

		return (
			<form className='form' id='login_form'>
				<p className='welcome-title'>Welcome to Passport!</p>
				<p className='welcome-body'>Please choose a new password ( at least 8 letters, including a number and an upper-case letter ) and click 'Change Password' to complete the process.</p>
				{ requireOldPassword && <UserInput
					validation={validation}
					id='inpOldPassword'
					name='inpOldPassword'
					isPassword={true}
					ref={inpOldPassword}
					labelText={null}
					errorText='You must enter your old password'
					placeholder='Enter OLD Password'
					tabIndex={3}
					value=''
					displayErrors={error.displayErrors}
					key='inpOldPassword'/> }
				{renderPasswordInput(true, 'New Password')}
				<UserInput
					validation={validation}
					id='inpPassword1'
					name='inpPassword1'
					isPassword={true}
					ref={inpOldPassword}
					labelText={null}
					errorText={errorMessage}
					placeholder='Confirm Password'
					tabIndex={3}
					value=''
					displayErrors={error.displayErrors}
					key='inpPassword1'/>
				<div className='form-group'>
					<button type='button' className='btn btn-primary' id='submitBtn' onClick={onChangePassword}>Change Password</button>
				</div>
				{ mode === 'change_password_first' && <div className='form-group'>
					<button type='button' className='btn btn-primary' id='logoutBtn' onClick={onLogout}>Logout</button>
				</div> }
				{ mode !== 'change_password_first' && <div className='form-group'>
					<button type='button' className='btn btn-primary' id='logoutBtn' onClick={onChangePasswordCancel}>Cancel</button>
				</div> }
			</form>
		)
    }

	const onClosePrivacyModal = () =>
	{
		doLoginFunctions( user );
	};

	const privacyStatementElement = () =>
	{
		return (
			<Modal key='privacyModal' center={true} open={dialogPrivacyOpen} closeOnOverlayClick={false} focusTrapped={false} showCloseIcon={false} onClose={onClosePrivacyModal}>
				<ModalPrivacyStatement onClose={onClosePrivacyModal}/>
			</Modal>
		)
	}

	const forgotPasswordLink = () =>
	{
		return (
			<a className='forgot-text' href='#' onClick={onForgotPassword}>Forgot Password</a>
		)
	}

	const formBody = () =>
	{
		switch ( mode )
		{
			case 'login':
			case 'activate':
			case 'password_reset_complete' :
				return (
					<Fragment>
						{ formElement() }
						{ forgotPasswordLink() }
					</Fragment>
				)
			case 'forgot_password':
				return forgotPasswordformElement() ;
			case 'change_password':
				return changePasswordformElement(true) ;
			case 'change_password_first':
				return changePasswordformElement(false) ;
			case 'register' :
				return registerElement() ;
			case 'password_reset':
				return passwordReset() ;
			case 'register_complete':
				return registerCompleteElement() ;
			case 'password_changed':
				return passwordChangeCompleteElement() ;
			case 'privacy_statement':
				return privacyStatementElement() ;
		}
	}

	return (
		<div className='login-container-inner'>
			{ suppressLogo !== true && logo ( defaultLogo )}
			{ title(heading) }
			{ formBody() }
		</div>
	)
}

export default LoginForm ;
